<template>
  <aside class="menu">
    <img src="../assets/logo_symbiofi.png" alt="Symbiofi logo" />
    <p class="menu-label">Menu</p>
    <ul class="menu-list">
      <li @click="selectMenu('accueil')" :class="{ 'active-link': currentMenu === 'accueil' }">Accueil</li>
      <li @click="selectMenu('questionnaire')" :class="{ 'active-link': currentMenu === 'questionnaire' }">Questionnaire</li>
      <li @click="selectMenu('bfp')" :class="{ 'active-link': currentMenu === 'bfp' }">Bilan Flash Psychologique</li>
      <li @click="selectMenu('list-psy')" :class="{ 'active-link': currentMenu === 'list-psy' }">Liste des thérapeutes</li>
      <li @click="selectMenu('list-user')" :class="{ 'active-link': currentMenu === 'list-user' }">Liste des utilisateurs</li>
      <li @click="selectMenu('maj')" :class="{ 'active-link': currentMenu === 'maj' }">Mise à jour</li>
      <li @click="selectMenu('scan3d-viewer')" :class="{ 'active-link': currentMenu === 'scan3d-viewer' }">Scan 3D</li>
      <li @click="selectMenu('statue3d-viewer')" :class="{ 'active-link': currentMenu === 'statue3d-viewer' }">Statue 3D</li>
      <li @click="selectMenu('jardin-viewer')" :class="{ 'active-link': currentMenu === 'jardin-viewer' }">Jardin 3D</li>
      <li @click="selectMenu('fontaine3d-viewer')" :class="{ 'active-link': currentMenu === 'fontaine3d-viewer' }">Fontaine 3D</li>
      <li @click="selectMenu('particules3d-viewer')" :class="{ 'active-link': currentMenu === 'particules3d-viewer' }">Particules 3D</li>
      <li @click="selectMenu('zebre-viewer')" :class="{ 'active-link': currentMenu === 'zebre-viewer' }">Zebre 3D</li>
      <li @click="deconnexion">Déconnexion</li>
    </ul>
  </aside>
</template>

<script>
import Parse from "parse";
import ParseConfig from "@/api/parse.config";

export default {
  name: 'MenuVertical',
  data() {
    return {
        currentMenu: 'accueil' // Pour stocker le nom du menu actuellement sélectionné
    };
},
  mounted() {
    // Sync the menu with the current route when component is mounted
    this.syncWithRoute();
  },
  watch: {
    // Keep the menu in sync when the route changes (direct URL, back/forward, etc.)
    '$route'() {
      this.syncWithRoute();
    }
  },
  methods: {
    syncWithRoute() {
      // Extract the last segment of the path to decide which menu item should be active
      const path = (this.$route && this.$route.path) ? this.$route.path : '';
      const parts = path.split('/').filter(Boolean);
      // If no specific child route, default to 'accueil'
      const last = parts.length === 0 ? 'accueil' : parts[parts.length - 1];
      this.currentMenu = last || 'accueil';
    },
    selectMenu(routeName) {
      this.currentMenu = routeName;
      this.$emit('menu-selected', routeName);
    },
    deconnexion() {
      //déconnecter l'utilisateur
      ParseConfig();
      Parse.User.logOut().then(() => {
        // Déconnexion réussie
        this.$emit('menu-selected', 'deconnexion');
      });
    }
  }
}
</script>
<style scoped>
.menu {
  width: 250px;
  height: 100vh; /* Pleine hauteur pour un affichage complet */
  background: linear-gradient(145deg, #f7f7f7, #e1e1e1); /* Gradient léger pour un aspect moderne */
  border-right: 1px solid #eaeaea;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Roboto', sans-serif; /* Police moderne */
  transition: all 0.3s ease;
  box-shadow: 4px 0 10px rgba(0,0,0,0.05); /* Ombre pour la profondeur */
}

img {
  width: 80%;
  height: auto;
  padding: 10px;
  margin-top: 20px;
  border-radius: 10px; /* coins arrondis pour l'image */
  box-shadow: 0 4px 10px rgba(0,0,0,0.1); /* Ombre sous le logo pour un effet flottant */
}

.menu-label {
  font-size: 1.4rem;
  margin: 20px 0;
  color: #444;
  letter-spacing: 1.2px;
}

.menu-list {
  list-style-type: none;
  padding: 0;
  width: 100%;
  border-top: 1px solid #dcdcdc; /* Bordure pour définir le début de la liste */
}

.menu-list li {
  padding: 15px 25px;
  width: 100%;
  text-align: center;
  transition: all 0.3s ease; /* Transition pour tous les changements */
  border-bottom: 1px solid #dcdcdc; /* Bordures entre éléments de la liste */
}

.menu-list li:hover, .menu-list .active-link {
  background-color: #00c4a7;
  color: white;
  cursor: pointer;
  transform: scale(1.02); /* Effet de zoom lors du survol pour indiquer l'interactivité */
}

.menu-list li:not(.active-link):hover {
  /* background-color: #e0f4f1; /* Un léger fond vert pour le survol */
  color: #333;
}

.active-link {
  font-weight: 600; /* Plus audacieux que 'bold' pour une meilleure distinction */
}
.menu-list .active-link {
  background-color: #00c4a7;
  color: white;
  font-weight: 700; /* Plus audacieux */
  position: relative; /* Pour positionner potentiellement un indicateur */
}

/* Icône ou indicateur pour l'élément actif (juste un exemple simple avec un pseudo-élément) */
.menu-list .active-link::before {
  content: '●'; /* Utilisation d'une coche comme indicateur */
  position: absolute;
  left: 10px; /* Positionnement à gauche de l'élément de menu */
  color: white; /* La même couleur que le texte de l'élément actif */
}

</style>
